<template>
 <div>
    <div class="lds-dual-ring" v-if="loading && !error"></div>
    <div v-if="error" class="error" id="login_error"><AlertCircleOutline/> panels not found</div>
    
  <div class="banner" v-if="!loading">
    <div class="bannercontent">
        <div class="logo"></div>
        <div class="bannertitle">{{panel.panelID}}</div>
        <div class="bannerdesc"><div class="tag">{{panel.date}}</div></div>
    </div>
  </div>

  <div class="content" v-if="!loading">
    <!-- <div class="label">Name</div>
    <input type="text" placeholder="Name" :value="panel.name" v-on:keyup="onChangeName($event)"/>
    <br>
    <div class="info"><AlertCircleOutline/> Name will be updated after testing is complete</div> -->
    <div class="panel" v-bind:style="{ backgroundImage: 'url(data:image/png;base64,'+ panel.panelTemplate.image + ')' }">
      <div class="dut" v-for="(dut, index) in panel.panelTemplate.DUTS" :key="dut.id"
      v-bind:style="{top: (850-dut.uiPos.y) + 'px', left: dut.uiPos.x + 'px'}">
        <div style="padding: 5px;">{{panel.orders[index].orderID}}</div>
        <router-link :to="'/result/'+result.testResultID" v-for="result in panel.orders[index].results" :key="result.resultID" class="result" v-bind:class="result.result">
          <!-- <div class="tag" v-bind:class="result.result">{{ result.result }}</div> -->
          
          <div class="label" v-if="result.result=='PASS'">Test completed</div>
          <div class="label" v-if="result.result=='FAIL'">{{ result.details[1].split(']')[3] }}</div>
          <div class="date">{{ result.date }}</div>
        </router-link>
      </div>
    </div>

  </div>
 </div>
</template>

<script>
// @ is an alias to /src
import AlertCircleOutline from 'vue-material-design-icons/AlertCircleOutline.vue'

export default {
  name: 'Panel',
  components: {
    AlertCircleOutline
  },
   data() {
    return{
      panel: [],
      loading: true,
      error: false
    }
  },
    mounted() {
      this.axios
      .get('/panel/get/'+this.$route.params.id)
      .then(response => {
          this.panel = response.data;
          this.loading = false
      })
      .catch(err => {
          this.error = true;
      });
  },
  methods: {
       
    }
}
</script>
<style scoped>
.date{
  display: inline-block;
  font-size: 12px;
  font-weight: bold;
}
.result
{
  display: inline-block;
  margin: 2px;
  padding: 3px;
  border-radius: 2px;
  text-align: left;
}
.panel
{
  display: block;
  
  width: 100%;
  height: 1024px;
  background-repeat: no-repeat;

  /* background-color: #2e2e2e; */
  position: relative;
}
.dut
{
  width: 250px;
  height: 200px;
  margin: 10px;
  background-color: #5c7080;
  opacity: 0.98;
  border-radius: 5px;
  position: absolute;
  color: white;
  text-align: center;
  top: 0;
  left: 0;
  overflow: scroll;
  border: 2px solid #3c4a54;
}
.save{
  float: right;
}
.save disabled{
  opacity: 1;
}
.label{
  display: inline-block;
  margin-right: 5px;
  min-width: 100px;
}
.info{
  color: #353535;
  margin-top: 5px;
}

.FAIL{
  background-color: #bd7171;
  color:#ffffff
}

.PASS {
  background-color: #67995b;
  color:#ffffff
}

.WARNING {
  background-color: #c78e3a;
  color:#ffffff
}
.tag {
	display: inline-block;
	margin-right: 2px;
	line-height: 15px;
	text-align: center;
}
</style>
